import { Fragment } from 'react/jsx-runtime';

export interface AlternatingTextProps {
  array: string[];
  boldFirst?: boolean;
  baseTextClassName?: string;
  altTextClassName?: string;
}

const AlternatingText: React.FunctionComponent<AlternatingTextProps> =
  function ({
    array,
    boldFirst = false,
    baseTextClassName = 'text-14-22 text-neutral-800',
    altTextClassName = 'text-14-22-em text-neutral-800',
  }) {
    return (
      <span className={baseTextClassName}>
        {array.map((segment, index) => {
          const showBold =
            (boldFirst && index % 2 === 0) || (!boldFirst && index % 2 === 1);
          if (showBold)
            return (
              <span key={segment} className={altTextClassName}>
                {segment}
              </span>
            );
          return <Fragment key={segment}>{segment}</Fragment>;
        })}
      </span>
    );
  };

export default AlternatingText;
